import React from "react";
import { useParams } from "react-router-dom";
import BillCard from "./BillCard";
import Pagination from "./Pagination";

const BillViewer = ({ allBillsData }) => {
  const { bill_id } = useParams();

  const sorted = [...allBillsData].sort(
    (a, b) =>
      parseInt(a.bill_number.replace(/\D/g, "")) -
      parseInt(b.bill_number.replace(/\D/g, ""))
  );

  const index = sorted.findIndex(
    (b) => b.bill_number.toLowerCase() === bill_id.toLowerCase()
  );
  const bill = sorted[index] ?? null;
  const prevBill = index > 0 ? `/${sorted[index - 1].bill_number}` : "/";
  const nextBill =
    index < sorted.length - 1 ? `/${sorted[index + 1].bill_number}` : "/";

  if (!bill) {
    return <div className="p-4 text-center">Bill not found</div>;
  }

  return (
    <div className="bill-viewer">
      <BillCard key={bill.bill_number} bill={bill} />
      <Pagination hasPrev={prevBill} hasNext={nextBill} page={index} />
    </div>
  );
};

export default BillViewer;